export const CONSUMER = 'consumer';
export const CONSUMERS = 'consumers';
export const MERCHANT = 'merchant';
export const MERCHANTS = 'merchants';

